import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const app = initializeApp({
  apiKey: 'AIzaSyBmuZN9NyfR_9iw4Y27QYyx4QMimo8JvnI',
  authDomain: 'studywise-e9542.firebaseapp.com',
  databaseURL: 'https://studywise-e9542-default-rtdb.firebaseio.com',
  projectId: 'studywise-e9542',
  storageBucket: 'studywise-e9542.appspot.com',
  messagingSenderId: '865072046772',
  appId: '1:865072046772:web:56b5b5ff84ed9915a3ade1',
  measurementId: 'G-G45D7JPSZT',
});

const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, app as default };
